{
  "dismiss": "Descartar"
}
